import React from "react";

/** returns a stateful container dimensions object that updates on window resize */
export function useElementBoundingClientRect(
  cssSelector: string
): DOMRect | null {
  const [elementDimensions, setElementDimensions] =
    React.useState<DOMRect | null>(null);

  React.useEffect(() => {
    const updateDimensions = () => {
      const element = document.querySelector(cssSelector);
      if (element) {
        setElementDimensions(element.getBoundingClientRect());
      }
    };
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, [cssSelector]);

  return elementDimensions;
}
